import { TFunction } from 'i18next';

/**
 * Get product data from i18n translations
 */
export const getProductData = (t: TFunction, productId: string) => {
  const productKey = `products.${productId}`;
  
  const aboutParagraphsResult = t(`${productKey}.aboutParagraphs`, { returnObjects: true });
  const featuresResult = t(`${productKey}.features`, { returnObjects: true });
  const screenshotsResult = t(`${productKey}.screenshots`, { returnObjects: true });
  
  const aiHighlightsResult = t(`${productKey}.aiHighlights`, { returnObjects: true });
  const aiDeepDiveParagraphsResult = t(`${productKey}.aiDeepDiveParagraphs`, { returnObjects: true });
  const useCasesResult = t(`${productKey}.useCases`, { returnObjects: true });

  return {
    name: t(`${productKey}.name`, ''),
    subtitle: t(`${productKey}.subtitle`, ''),
    aiIntroTitle: t(`${productKey}.aiIntroTitle`, '') || undefined,
    aiIntroTagline: t(`${productKey}.aiIntroTagline`, '') || undefined,
    aiIntroDescription: t(`${productKey}.aiIntroDescription`, '') || undefined,
    aboutTitle: t(`${productKey}.aboutTitle`, ''),
    aboutParagraphs: Array.isArray(aboutParagraphsResult) 
      ? (aboutParagraphsResult as string[])
      : [],
    aiHighlightsTitle: t(`${productKey}.aiHighlightsTitle`, '') || undefined,
    aiHighlights: Array.isArray(aiHighlightsResult)
      ? (aiHighlightsResult as Array<{ emoji: string; title: string; description: string }>)
      : undefined,
    aiDeepDiveTitle: t(`${productKey}.aiDeepDiveTitle`, '') || undefined,
    aiDeepDiveParagraphs: Array.isArray(aiDeepDiveParagraphsResult)
      ? (aiDeepDiveParagraphsResult as string[])
      : undefined,
    useCasesTitle: t(`${productKey}.useCasesTitle`, '') || undefined,
    useCases: Array.isArray(useCasesResult)
      ? (useCasesResult as Array<{ scenario: string; benefit: string }>)
      : undefined,
    features: Array.isArray(featuresResult)
      ? (featuresResult as Array<{ emoji: string; title: string; description: string }>)
      : [],
    sidebarTitle: t(`${productKey}.sidebarTitle`, ''),
    sidebarDescription: t(`${productKey}.sidebarDescription`, ''),
    whyPlayTitle: t(`${productKey}.whyPlayTitle`, '') || undefined,
    whyPlayDescription: t(`${productKey}.whyPlayDescription`, '') || undefined,
    screenshots: Array.isArray(screenshotsResult)
      ? (screenshotsResult as Array<{ label: string }>)
      : [],
  };
};

